<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: [
    "values",
    "labels",
    "colors",
    "title",
    "semicircle",
    "legendPosition",
    "displayLegend"
  ],
  data() {
    return {
      options: {
        responsive: true,
        legend: {
          position: this.legendPosition ? this.legendPosition : "bottom",
          display: this.displayLegend
        },
        title: {
          display: this.title,
          text: this.title
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        circumference: this.semicircle ? Math.PI : 2 * Math.PI,
        rotation: this.semicircle ? -Math.PI : -Math.PI / 2
      }
    };
  },
  computed: {
    data() {
      return {
        datasets: [
          {
            data: this.values,
            backgroundColor: this.colors,
            label: "Bla"
          }
        ],
        labels: this.labels
      };
    }
  },
  mounted() {
    this.renderChart(this.data, this.options);
  }
};
</script>
